export type AuthApiVersions = keyof typeof AUTH_API_PATHS;
export const AUTH_API_PATHS = {
    V1: {
        AUTH: {
            LOGIN: 'v1/auth/login',
            CHECK_SESSION: 'v1/auth/check-session',
            ME: 'v1/auth/me',
            REFRESH: 'v2/auth/refresh',
            LOGOUT: 'v2/auth/logout',
            SEND_RECOVERY_EMAIL: 'v1/auth/send-recovery-email',
        },
    },
    V2: {
        AUTH: {
            LOGIN: 'v2/auth/login',
            LOGIN_THROUGH_THIRD_PARTY: 'v2/auth/login-through-third-party',
            REGISTER: 'v2/auth/register',
            ME: 'v2/auth/me',
            REDIRECT: 'v2/auth/redirect',
            REFRESH: 'v2/auth/refresh',
            LOGOUT: 'v2/auth/logout',
            VERIFY_EMAIL: 'v2/auth/verify-email',
            REQUEST_EMAIL_CHANGE: 'v2/auth/request-email-change',
            CHANGE_PASSWORD: 'v2/auth/change-password',
            IDP: 'v2/auth/idp/me',
            SELECT_ORGANIZATION: 'v2/auth/select-organization',
            REQUEST_PHONE_NUMBER_CHANGE: 'v2/auth/sms/request-phone-verification',
            VERIFY_PHONE_NUMBER_CHANGE: 'v2/auth/sms/check-verification-code',
            CROSS_CHECK_SESSION: 'v2/auth/cross-check-session',
            EXCHANGE_EXTERNAL_TOKEN: 'v2/auth/exchange-external-token',
        },
    },
};
